"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DestinationPicker = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _Flags = _interopRequireDefault(require("@lt/components/components/Flags"));

var _styles = require("@lt/components/components/DurationTrip/styles");

var _utils = require("../../../../utils");

var _constants = require("../../constants");

var _usehooksTs = require("usehooks-ts");

var _BackWizardButton = require("../BackWizardButton/BackWizardButton");

var _styles2 = require("../../styles");

var _Control = _interopRequireDefault(require("./components/Control"));

var _Group = _interopRequireDefault(require("./components/Group"));

var _Option = _interopRequireDefault(require("./components/Option"));

var _Input = _interopRequireDefault(require("./components/Input"));

var _NoOptionsMessage = require("./components/NoOptionsMessage/NoOptionsMessage");

var _SingleValue = _interopRequireDefault(require("./components/SingleValue"));

var _ValueContainer = _interopRequireDefault(require("./components/ValueContainer"));

var _constants2 = require("./constants");

var _CloseButton = _interopRequireDefault(require("../CloseButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FlagSprites = (0, _styledComponents.createGlobalStyle)(["", ""], (0, _Flags["default"])());

var DestinationPicker = function DestinationPicker(_ref) {
  var options = _ref.options,
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
      value = _ref.value,
      inputValue = _ref.inputValue,
      onInputChange = _ref.onInputChange,
      isWizardOpen = _ref.isWizardOpen,
      isWizard = _ref.isWizard,
      menuIsOpen = _ref.menuIsOpen,
      isDisabled = _ref.isDisabled,
      onMenuOpen = _ref.onMenuOpen,
      onMenuClose = _ref.onMenuClose,
      onChange = _ref.onChange,
      onKeyDown = _ref.onKeyDown,
      changeOptions = _ref.changeOptions,
      className = _ref.className,
      searchType = _ref.searchType,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      _ref$isWidget = _ref.isWidget,
      isWidget = _ref$isWidget === void 0 ? false : _ref$isWidget,
      _ref$isWhiteLabel = _ref.isWhiteLabel,
      isWhiteLabel = _ref$isWhiteLabel === void 0 ? false : _ref$isWhiteLabel,
      isLoading = _ref.isLoading;
  var ref = (0, _react.useRef)(null);
  var showBackButton = !!menuIsOpen && isWizard;
  var showCloseButton = isMobile && !!menuIsOpen && !isWizard;
  var showLoader = isLoading && !inputValue && searchType !== _constants.SEARCH_TYPE_NAMES.TRIP;
  (0, _react.useEffect)(function () {
    if (menuIsOpen && ref.current) {
      ref.current.focus();

      if (_utils.isIOS && !isWidget) {
        setTimeout(function () {
          // Хак из-за того, что из-за клавиатуры инпут на айфоне улетает вверх
          // TODO: Убрать это и сделать нормально
          window.scrollTo(0, 0);
        }, 500);
      }
    }
  }, [isWidget, menuIsOpen]);
  /**
   * После открытия меню в визарде скрываем клавиатуру
   * Без этого в некоторых версиях iOS нельзя отредактировать поле
   */

  (0, _react.useEffect)(function () {
    if (!isWizard) return;
    var blurTimer = setTimeout(function () {
      var _ref$current, _ref$current$inputRef;

      (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : (_ref$current$inputRef = _ref$current.inputRef) === null || _ref$current$inputRef === void 0 ? void 0 : _ref$current$inputRef.blur();
    }, 200);
    return function () {
      clearTimeout(blurTimer);
    };
  }, [isWizard]);
  /**
   * При переключении типа поиска на экскурсии нужно очистить поле, если
   * до этого в нём была опция другого типа поиска
   * И наоборот при переключении типа поиска с экскурсий на обычный
   * нужно очистить поле, т.к. иначе поиск будет не того формата
   */

  (0, _react.useEffect)(function () {
    var _ref$current2;

    /* TODO: LT-37919 - разрулить некорректные данные на уровне стейта */
    if (!_utils.isTouchScreen) return;
    (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.clearValue();
  }, [searchType]); // Если тыкаем где-то за пределами инпута, то скрываем клавиатуру на мобильном устройстве

  (0, _usehooksTs.useEventListener)('touchstart', function (event) {
    var _ref$current3;

    var el = (_ref$current3 = ref.current) === null || _ref$current3 === void 0 ? void 0 : _ref$current3.controlRef;

    if (!el || el.contains(event.target)) {
      // Хак для Webview, без этого не работает тач по полю
      isWizard && onMenuOpen && onMenuOpen();
      return;
    }

    setTimeout(function () {
      var _ref$current4, _ref$current4$inputRe;

      (_ref$current4 = ref.current) === null || _ref$current4 === void 0 ? void 0 : (_ref$current4$inputRe = _ref$current4.inputRef) === null || _ref$current4$inputRe === void 0 ? void 0 : _ref$current4$inputRe.blur();
    }, 200);
  }); // По клику в инпут сдвигаем мигающий курсор в конец строки
  // и убираем выделение содержимого инпута

  var onFocus = function onFocus() {
    var _ref$current5;

    var inputRef = (_ref$current5 = ref.current) === null || _ref$current5 === void 0 ? void 0 : _ref$current5.inputRef;
    if (!inputRef) return;
    value && inputRef.select();
    setTimeout(function () {
      inputRef.setSelectionRange(inputRef.value.length, inputRef.value.length);
    }, 0);
  };

  var isAbsolute = !isWidget || isWidget && isMobile;
  var selectStyles = {
    placeholder: function placeholder(styles) {
      return _objectSpread(_objectSpread({}, styles), isAbsolute && {
        position: 'absolute'
      });
    },
    control: function control(styles) {
      return _objectSpread(_objectSpread({}, styles), showLoader && {
        justifyContent: 'flex-start'
      });
    },
    loadingIndicator: function loadingIndicator(styles) {
      return _objectSpread(_objectSpread({}, styles), showLoader && {
        position: 'absolute',
        top: '16px',
        left: '32px'
      });
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isMobile && !isWizard && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledMobileLabel, {
    $isWhiteLabel: isWhiteLabel,
    $variant: variant
  }, (0, _constants2.placeholder)(true)), menuIsOpen && /*#__PURE__*/_react["default"].createElement(StyledCloseButton, {
    onClick: onMenuClose
  })), /*#__PURE__*/_react["default"].createElement(SelectContainer, {
    $withBackButton: showBackButton,
    $withCloseButton: showCloseButton,
    $isMobile: isMobile,
    $isWizardOpen: isWizardOpen,
    $isWizard: isWizard,
    $isWhiteLabel: isWhiteLabel,
    $menuIsOpen: menuIsOpen,
    className: className,
    $searchType: searchType,
    $hasVisaLabel: Boolean(value === null || value === void 0 ? void 0 : value.visa),
    $variant: variant,
    $isWidget: isWidget
  }, /*#__PURE__*/_react["default"].createElement(FlagSprites, null), /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], {
    styles: selectStyles,
    ref: ref,
    onInputChange: onInputChange,
    className: _constants2.destinationPickerName,
    classNamePrefix: _constants2.destinationPickerName,
    placeholder: showLoader ? '' : (0, _constants2.placeholder)(menuIsOpen, searchType),
    options: options,
    isClearable: true,
    backspaceRemovesValue: true,
    escapeClearsValue: false,
    inputValue: !_utils.isTouchScreen || _utils.isTouchScreen && menuIsOpen ? inputValue : undefined
    /**
     * Нужно, чтобы при очищении поля в нём не оставалось
     * ранее выбранное значение
     */
    ,
    value: inputValue ? value : null,
    onMenuOpen: onMenuOpen,
    filterOption: function filterOption() {
      return true;
    },
    onMenuClose: _utils.isTouchScreen ? undefined : onMenuClose,
    isMobile: _utils.isTouchScreen,
    onChange: onChange,
    onKeyDown: onKeyDown,
    onFocus: onFocus,
    menuIsOpen: menuIsOpen,
    menuShouldScrollIntoView: false,
    isDisabled: isDisabled,
    changeOptions: changeOptions,
    isMulti: false,
    components: _objectSpread(_objectSpread({
      Control: _Control["default"],
      Group: _Group["default"],
      Option: _Option["default"],
      Input: _Input["default"],
      NoOptionsMessage: _NoOptionsMessage.NoOptionsMessage,
      LoadingMessage: function LoadingMessage() {
        return null;
      },
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      },
      DropdownIndicator: function DropdownIndicator() {
        return null;
      },
      ClearIndicator: function ClearIndicator() {
        return null;
      }
    }, _utils.isTouchScreen ? {
      SingleValue: _SingleValue["default"]
    } : {
      SingleValue: function SingleValue() {
        return null;
      }
    }), {}, {
      ValueContainer: _ValueContainer["default"]
    }),
    isSearchable: !_utils.isTouchScreen || menuIsOpen,
    isLoading: showLoader,
    "aria-label": (0, _constants2.placeholder)(menuIsOpen)
  })));
};

exports.DestinationPicker = DestinationPicker;

var SelectContainer = _styledComponents["default"].div.withConfig({
  displayName: "DestinationPicker__SelectContainer",
  componentId: "sc-h5j8y1-0"
})(["pointer-events:auto;display:flex;position:relative;align-items:center;width:100%;flex-grow:", ";", " .", "{width:100%;position:initial;background-color:#fff;border-radius:var(--border-radius) 0 0 var(--border-radius);color:#17181a;&__control{min-width:200px;padding:8px;font-size:18px;line-height:22px;border:0;box-shadow:none;height:56px;caret-color:#007aff;border-radius:var(--border-radius) 0 0 var(--border-radius);color:#17181a;font-weight:500;&--menu-is-open{font-weight:normal;}&:hover{border:0;box-shadow:none;}&-visa{display:none;}}&__option{position:relative;padding:0;color:inherit;width:initial;&--is-focused{background-color:var(--background);}&--is-selected{background-color:var(--background);}&:active{background-color:var(--grey3);}}&__placeholder{color:var(--grey2);font-weight:400;}&__placeholder,&__input-container{padding:0;margin:0;}&__input-container{visibility:visible;z-index:1;grid-template-columns:1fr;> input{grid-area:1 / 1 !important;}}&__indicators span{height:10px;width:10px;border-radius:50%;}", " &__menu{margin:0;box-shadow:var(--box-shadow);width:320px;z-index:9999;border-radius:var(--border-radius);}&__menu-list{position:initial;max-height:554px;padding:0;}&__group-heading{text-transform:none;font-size:12px;line-height:16px;padding-left:8px;padding-right:8px;margin-bottom:8px;color:var(--grey1);font-weight:400;font-size:12px;line-height:14px;}&__countries,&__popularCountries,&__popularDirections{& .", "__option::after,.", "__option::after{content:'';position:absolute;top:0;bottom:0;left:0;width:100%;}}&__allMetaregions{height:554px;border-radius:4px 0 0 4px;}&__allCountries{width:778px;height:554px;background-color:var(--white);position:absolute;", " top:0;overflow:", ";padding:10px 8px;border-radius:0 var(--border-radius) var(--border-radius) 0;& > :last-child{height:100%;display:flex;flex-flow:column wrap;align-content:space-between;}}}", ";", " ", ";", ";", ";", ";", ""], function (_ref2) {
  var $isMobile = _ref2.$isMobile;
  return $isMobile ? 0 : 2;
}, function (_ref3) {
  var $isMobile = _ref3.$isMobile,
      $isWizard = _ref3.$isWizard,
      $menuIsOpen = _ref3.$menuIsOpen;
  return $isMobile && !$isWizard && $menuIsOpen && (0, _styledComponents.css)(["position:fixed;top:0;&:before{content:'';top:0;background:black;}"]);
}, _constants2.destinationPickerName, function (_ref4) {
  var $isMobile = _ref4.$isMobile;
  return !$isMobile && "\n      /* fix small input touch region bug */\n      &__input-container {\n        display: block;\n\n        & > input {\n          display: inline-block;\n        }\n\n        &::after {\n          content: none;\n        }\n      }\n    ";
}, _constants2.destinationPickerName, _constants2.destinationPickerName, function (_ref5) {
  var $searchType = _ref5.$searchType;
  return $searchType === _constants.SEARCH_TYPE_NAMES.PACKAGE && "left: 100%;";
}, function (_ref6) {
  var $isMobile = _ref6.$isMobile;
  return $isMobile ? 'auto' : 'hidden';
}, function (_ref7) {
  var $isMobile = _ref7.$isMobile;
  return $isMobile && (0, _styledComponents.css)([".", "{border-radius:var(--border-radius);&__control{width:100%;", ";padding:0;}&__menu{height:100vh;width:100%;left:0;border-radius:0;box-shadow:none;&-list{max-height:none;height:calc(100vh - ", ");}}&__placeholder{font-weight:400;color:var(--grey2);}&__allCountries{width:initial;position:initial;padding-bottom:60px;height:calc(100vh - ", ");overflow:initial;& > :last-child{display:block;}.", "__option:last-of-type{padding-bottom:60px;}}&__icon-search{display:none;}}"], _constants2.destinationPickerName, _styles2.mobileDefaultControlStyles, _utils.isIOS ? '150px' : '64px', _utils.isIOS ? '150px' : '64px', _constants2.destinationPickerName);
}, function (_ref8) {
  var $isWizard = _ref8.$isWizard,
      $menuIsOpen = _ref8.$menuIsOpen;
  return $isWizard && (0, _styledComponents.css)(["max-height:none;& + ", "{stroke:#007aff;}.", "{&__menu{border-radius:0;box-shadow:none;}&__control{height:", ";", ";border:none;&--is-disabled{background-color:#fff;}}&__group-heading{margin-top:8px;}&__icon-search{display:initial;}&__single-value--is-disabled{color:inherit;}}"], _BackWizardButton.ArrowLeftIcon, _constants2.destinationPickerName, $menuIsOpen ? "48px" : "initial", $menuIsOpen ? "padding-left: 8px" : "padding: 16px 16px 16px 8px");
}, function (_ref9) {
  var $withBackButton = _ref9.$withBackButton;
  return $withBackButton && (0, _styledComponents.css)(["position:fixed;top:0;left:0;z-index:1;padding:8px 8px 8px 56px;background-color:var(--primary-header);.", "{&__control{border:none;}}"], _constants2.destinationPickerName);
}, function (_ref10) {
  var $isWizardOpen = _ref10.$isWizardOpen,
      $withBackButton = _ref10.$withBackButton,
      $hasVisaLabel = _ref10.$hasVisaLabel;
  return $isWizardOpen && !$withBackButton && (0, _styledComponents.css)([".", "{padding:", ";background-color:var(--primary-header);background-size:cover;border-radius:0;&:after{content:'';position:absolute;padding:8px;background-color:var(--white);bottom:0;left:0;right:0;}&__control{width:fit-content;height:auto;min-width:0;border-radius:var(--border-radius);margin:auto;border:none;font-weight:normal;padding:4px 16px 8px;display:flex;flex-direction:column;&-visa{display:inline-block;font-size:12px;line-height:16px;color:#919499;}}&__single-value,&__value-container,&__input-container{display:flex;margin:0;padding:0;}&__icon-search{display:none;}}"], _constants2.destinationPickerName, $hasVisaLabel ? '8px 56px 24px' : '12px 56px 24px');
}, function (_ref11) {
  var $withCloseButton = _ref11.$withCloseButton;
  return $withCloseButton && (0, _styledComponents.css)(["position:fixed;transform:translate3d(0,0,0);top:0;left:0;right:0;z-index:1;padding:8px 56px 8px 8px;background-color:'var(--primary-header)';.", "{&__control{border:none;}&__icon-search{display:inline;margin-left:8px;}&__value-container{display:flex;}&__menu{background-color:var(--background);max-height:none;&-list{max-height:none;background-color:#fff;height:calc(100vh - ", ");}}}"], _constants2.destinationPickerName, _utils.isIOS ? '150px' : '64px');
}, function (_ref12) {
  var $isMobile = _ref12.$isMobile,
      $isWizard = _ref12.$isWizard;
  return !$isMobile && !$isWizard && (0, _styledComponents.css)([".", "__icon-search{display:none;}"], _constants2.destinationPickerName);
}, function (_ref13) {
  var $isMobile = _ref13.$isMobile,
      $isWizard = _ref13.$isWizard,
      $isWidget = _ref13.$isWidget;
  return $isWidget && $isMobile && !$isWizard && _styles2.mobileWidgetInputStyles;
}); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore


var StyledCloseButton = (0, _styledComponents["default"])(_CloseButton["default"]).attrs({
  $inMobileInput: true
}).withConfig({
  displayName: "DestinationPicker__StyledCloseButton",
  componentId: "sc-h5j8y1-1"
})(["position:fixed;margin:0px;right:16px;top:20px;"]);
var StyledMobileLabel = (0, _styledComponents["default"])(_styles.MobileLabel).withConfig({
  displayName: "DestinationPicker__StyledMobileLabel",
  componentId: "sc-h5j8y1-2"
})(["margin-bottom:8px;"]);